var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMappingpartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "69.000000pt",
    height: "60.000000pt",
    viewBox: "0 0 69.000000 60.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,60.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 449 c-37 -29 -35 -70 5 -102 l31 -24 -35 -6 c-60 -10 -87 -34 -87 -78 0 -22 5 -39 10 -39 6 0 10 13 10 28 0 45 32 67 99 67 31 0 64 -4 74 -9 12 -6 17 -4 17 8 0 11 -13 18 -41 22 l-41 7 31 24 c40 32 42 73 5 102 -15 12 -32 21 -39 21 -7 0 -24 -9 -39 -21z m78 -31 c14 -23 -3 -52 -33 -56 -42 -6 -67 38 -39 66 17 17 58 11 72 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 449 c-37 -29 -35 -70 5 -102 l31 -24 -41 -7 c-28 -4 -41 -11 -41 -22 0 -12 5 -14 18 -8 37 16 100 16 136 -1 31 -15 36 -22 36 -51 0 -19 5 -34 10 -34 6 0 10 18 10 39 0 47 -23 68 -84 78 l-38 6 31 24 c40 32 42 73 5 102 -15 12 -32 21 -39 21 -7 0 -24 -9 -39 -21z m78 -31 c14 -23 -3 -52 -33 -56 -42 -6 -67 38 -39 66 17 17 58 11 72 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 353 c-19 -23 -23 -41 -14 -75 13 -49 93 -51 115 -3 29 63 -56 128 -101 78z m67 -16 c38 -27 -2 -95 -41 -71 -25 16 -29 55 -7 71 10 7 21 13 24 13 3 0 14 -6 24 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 218 c-48 -17 -75 -47 -75 -85 0 -18 5 -33 10 -33 6 0 10 14 10 30 0 46 48 72 122 67 67 -4 98 -26 98 -69 0 -15 5 -28 10 -28 6 0 10 16 10 35 0 45 -28 71 -92 84 -57 13 -54 13 -93 -1z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappingpartner);
export default __webpack_public_path__ + "static/media/mappingpartner.8847f79fa73914d4d562cda8d897461a.svg";
export { ForwardRef as ReactComponent };